import { useCommon } from "./common";

export const useApiUtil = () => {
  const commonJs = useCommon();

  /**
   * API 호출 함수
   * @param {object} options
   * @param {'get' | 'post' | 'put' | 'delete'} options.method - HTTP 메서드
   * @param {string} options.url - API 주소
   * @param {object} [options.params] - GET용 파라미터
   * @param {object} [options.data] - POST/PUT용 바디 데이터
   * @param {function} [options.mapper] - 응답 데이터 가공 함수
   * @param {boolean} [options.showMsg] - 성공 시 메시지 표시 여부 (기본 true)
   * @returns {Promise<any>} 처리된 데이터 또는 응답 객체
   */
  const gfnCallApi = async ({
    method = "POST",
    url,
    params = {},
    data = {},
    mapper,
    showMsg = true,
    isMultipart = false,
  }) => {
    try {
      const isGet = method.toLowerCase() === "get";
      const payload = isGet ? params : data;
            
      const response = await commonJs.apiRequest(
                                    method, 
                                    "/api/front/" + url, 
                                    payload,
                                    isMultipart
                                      ? { headers: { "Content-Type": "multipart/form-data" } }
                                      : { headers: { "Content-Type": "application/json" } }                                    
                                  );
      
      if (!response) {
        return null;
      }

      if (!response.success) {
        const errorMessage = response.error?.message ||
          (typeof response.error === "string" ? response.error : null) ||
          "API 처리 중 오류가 발생했습니다.";
        commonJs.showToastMsg(errorMessage, "error");
        return null;
      }

      let resData = response.data?.data;
      if(!resData) resData = { data: response.data};
      if(!resData.data) {
        resData.header = [];
        resData.data = [];
      }

      resData.code = response.data.code;
      resData.message = response.data.message;

      if (showMsg && method !== "get" && resData.code === 0) {
        commonJs.showToastMsg("처리되었습니다.");
      }


      return mapper ? (Array.isArray(resData) ? resData.map(mapper) : mapper(resData)) : resData;
    } catch (error) {
      console.error("API 호출 실패:", error);
      commonJs.showToastMsg("API 호출 중 오류 발생", "error");
      return null;
    }
  };

const gfnOpenApiFront = (path, token) => {
  const uiOrigin = window.location.origin;
  const url = `${uiOrigin}/${path}?token=${token}`;

  window.open(url, "_blank");
};

  return { gfnCallApi, gfnOpenApiFront };
};